import React from "react";

export default function LocationSection(props) {
  const locationSectionList = props?.LocationSection?.content?.list_item
  return (
    <div className="city-state-container location-wrapper">
    <div className="location-section">
    <div className="container-fluid">
        {/* <h2 className="pb-3">{props?.LeftImage?.content?.configuration[0]?.headline}</h2> */}
        <div className="row">
          <div className="col-sm-12 col-md-5">
              <h4>{locationSectionList[0]?.list_text}</h4>
                <div className="location-block">
                <img alt={locationSectionList[0]?.icon_image?.alt} src={locationSectionList[0]?.icon_image?.filename}/>
                  <span>{locationSectionList[0]?.description?.content[0]?.content[0]?.text}</span>
                </div>
          </div>

          <div className="col-sm-12 col-md-2">
            <div className="or-section">Or</div>
          </div>
          <div className="col-sm-12 col-md-5">
             <h4>{locationSectionList[1]?.list_text}</h4>
              <div className="phone-number text-orange orange-link">
                <img alt={locationSectionList[1]?.icon_image?.alt} src={locationSectionList[1]?.icon_image?.filename}/>
                <a href={"tel:" + locationSectionList[1]?.description?.content[0]?.content[0]?.text}><b>{locationSectionList[1]?.description?.content[0]?.content[0]?.text}</b></a>
              </div>
          </div>
        </div>
      </div>
    </div>
      
    </div>
  );
}
